import { gql } from '@apollo/client';

/**
 * 建联跟进时间线（某站点 operation_log 按发生先后）。详情按需查，列表不返（避免 N+1）。
 */
export const GET_STATION_LINK_TIMELINE = gql`
  query GetStationLinkTimeline($cooperationWarehouseId: Long!) {
    getStationLinkTimeline(cooperationWarehouseId: $cooperationWarehouseId) {
      id
      operationType
      operatorName
      content
      proofS3Urls
      time
    }
  }
`;

export interface FollowUpTimelineEventDto {
  id: number | null;
  operationType: number | null;
  operatorName: string | null;
  content: string | null;
  /** content 里 proofS3Keys 预签后的可访问图片 URL（后端预签，前端直接 <img>）。 */
  proofS3Urls: string[] | null;
  time: string | null;
}

export interface GetStationLinkTimelineResponse {
  getStationLinkTimeline: FollowUpTimelineEventDto[];
}
